import {
	PRODUCT_STOCK_GET,
	TYPE_MOVEMENTS_GET,
	PRODUCT_MOVEMENT_CREATE,
	PRODUCT_MOVEMENTS_GET,
	PRODUCT_MOVEMENT_DELETE,
	PRODUCT_STOCK_REMOVE,
	PRODUCT_PURCHASE_PRICE_GET,
	PRODUCT_PURCHASE_PRICE_SET,
	PRODUCT_PURCHASE_PRICE_DELETE,
	PRODUCT_PURCHASE_PRICE_BULK_SET,
	PRODUCT_PURCHASE_PRICE_BULK_DELETE,
} from '../constants/productStock';

export const getProductStock = id_menu => ({
	type: PRODUCT_STOCK_GET,
	id_menu,
});

export const getTypeMovements = () => ({
	type: TYPE_MOVEMENTS_GET,
});

export const createMovement = data => ({
	type: PRODUCT_MOVEMENT_CREATE,
	data,
});

export const getMovements = id_product => ({
	type: PRODUCT_MOVEMENTS_GET,
	id_product,
});

export const deleteMovement = (id_movement, id_product, delta, id_menu) => ({
	type: PRODUCT_MOVEMENT_DELETE,
	id_movement,
	id_product,
	delta,
	id_menu,
});

export const removeFromStock = (id_product, id_menu) => ({
	type: PRODUCT_STOCK_REMOVE,
	id_product,
	id_menu,
});

export const getPurchasePrice = id_product => ({
	type: PRODUCT_PURCHASE_PRICE_GET,
	id_product,
});

// effective_day ('YYYY-MM-DD') est facultatif : sans lui, le serveur écrit à
// la date sélectionnée dans le calendrier de l'app.
export const setPurchasePrice = (id_product, unit_value, effective_day) => ({
	type: PRODUCT_PURCHASE_PRICE_SET,
	id_product,
	unit_value,
	effective_day,
});

export const deletePurchasePrice = id_product => ({
	type: PRODUCT_PURCHASE_PRICE_DELETE,
	id_product,
});

export const bulkSetPurchasePrice = items => ({
	type: PRODUCT_PURCHASE_PRICE_BULK_SET,
	items,
});

export const bulkDeletePurchasePrice = id_products => ({
	type: PRODUCT_PURCHASE_PRICE_BULK_DELETE,
	id_products,
});
